
import React, { useEffect } from 'react';
import { CheckCircle2, AlertCircle, X, Info } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  isVisible: boolean;
  onClose: () => void;
}

const ToastNotification: React.FC<ToastProps> = ({ message, type, isVisible, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const styles = {
    success: { bg: 'bg-emerald-500', icon: <CheckCircle2 size={20} className="text-white" /> },
    error: { bg: 'bg-rose-500', icon: <AlertCircle size={20} className="text-white" /> },
    info: { bg: 'bg-blue-500', icon: <Info size={20} className="text-white" /> }
  };

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-[100] animate-in slide-in-from-top-5 fade-in duration-300 w-full max-w-sm px-4">
      <div className={`${styles[type].bg} px-4 py-3 rounded-xl shadow-lg shadow-black/10 flex items-center gap-3 w-full`}>
        {styles[type].icon}
        <p className="text-white font-bold text-sm flex-grow font-sans">{message}</p>
        <button onClick={onClose} className="text-white/80 hover:text-white transition-colors">
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;
